var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.orderInfo)?_c('div',{staticClass:"price-wrapper"},[_vm._v(" 实付金额："),_c('span',{staticClass:"price"},[_c('span',[_vm._v("￥")]),_vm._v(_vm._s(_vm.orderInfo.actualPrice))])]):_vm._e(),_c('div',{staticClass:"count-down"},[_vm._v(_vm._s(_vm.countdownText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }